var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOutSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22,28c0,0.5517578-0.4482422,1-1,1H7c-0.5517578,0-1-0.4482422-1-1V4c0-0.5517578,0.4482422-1,1-1h14 c0.5517578,0,1,0.4482422,1,1v4h2V4c0-1.6542969-1.3457031-3-3-3H7C5.3457031,1,4,2.3457031,4,4v24c0,1.6542969,1.3457031,3,3,3h14 c1.6542969,0,3-1.3457031,3-3v-4h-2V28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7070312,15.2929688l-5-5l-1.4140625,1.4140625l3.2886963,3.2886963L10,15v2l16.59021-0.0042725l-3.2972412,3.2972412 l1.4140625,1.4140625l5-5C30.0976562,16.3164062,30.0976562,15.6835938,29.7070312,15.2929688z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutSmall);
export default __webpack_public_path__ + "static/media/log-out--small.bef2f802ccfcb60d66ef386a105e2599.svg";
export { ForwardRef as ReactComponent };